import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import Logo from "../ui/logo";
import { MarketRecapWizard } from "./MarketRecapWizard";
import { useNavigate } from "@tanstack/react-router";

export function MarketRecapPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate({ to: "/", search: { slide: undefined } });
  };

  return (
    <div className="flex flex-col h-screen w-full bg-background">
      {/* Subtle Ambient Background */}
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.15),rgba(255,255,255,0))] dark:bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))]"></div>
      </div>

      {/* Header - Fixed */}
      <header className="flex-shrink-0 z-50 w-full bg-background/80 backdrop-blur-xl border-b border-white/10">
        <div className="px-4 py-2">
          <div className="flex items-center gap-4">
            {/* Back Button */}
            <Button
              variant="ghost"
              size="sm"
              onClick={handleBack}
              className="h-9 w-9 p-0 hover:bg-muted rounded-lg transition-all"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>

            {/* Logo */}
            <Logo variant="modern" className="h-9" />

            {/* Title */}
            <div className="flex-1">
              <h1 className="text-lg font-semibold text-foreground">
                Market Recap
              </h1>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content - Scrollable */}
      <main className="flex-1 overflow-y-auto">
        {/* Hero Section */}
        <section className="relative pt-8 pb-4">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center space-y-2 max-w-3xl mx-auto">
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
                <span className="text-foreground">Create a </span>
                <span className="text-gradient-purple">Market Recap</span>
                <span className="text-foreground"> Slide</span>
              </h2>
              <p className="text-sm text-muted-foreground max-w-xl mx-auto">
                Choose a recap type, fill in the details, and select a visual template.
              </p>
            </div>
          </div>
        </section>

        {/* Wizard */}
        <section className="relative pb-8">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <MarketRecapWizard />
          </div>
        </section>
      </main>
    </div>
  );
}
